<template>
<footer class="footer">
  <div class="footer-container">
    <div class="footer-note">
      &copy; 2026 <a href="https://gbfreeapk.com" class="footer-link">gbfreeapk.com</a> This site is not affiliated with WhatsApp or Meta. APKs are from third-party sources for educational use only.
    </div>
    <div class="footer-links">
      <a href="/about-us/" class="footer-link">About Us</a>
      <span class="footer-divider">|</span>
      <a href="/disclaimer/" class="footer-link">Disclaimer</a>
      <span class="footer-divider">|</span>
      <a href="/privacy-policy/" class="footer-link">Privacy Policy</a>
    </div>
  </div>
</footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style lang="scss" scoped>
.footer {
  background-color: #fff;
  color: #121212;
  padding: 15px 0;
}

.footer-container {
  width: 80%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.footer-links {
  display: flex;
  align-items: center;
  gap: 10px;
}

.footer-divider {
  color: #666;
  font-size: 14px;
}

.footer-link {
  color: #1b3d76;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s;
}

.footer-link:hover {
  color: #2880ba;
}

.footer-note {
  font-size: 15px;
  text-align: center;
}

@media (max-width: 768px) {
  .footer {
    padding: 10px 0;
  }

  .footer-note {
    font-size: 12px;
  }

  .footer-link {
    font-size: 12px;
  }

  .footer-divider {
    font-size: 12px;
  }
}
</style>
